import axios from 'axios'
import { useEffect, useState } from 'react'

// Custom hook to check if a WordPress page exists and fetch its content
export function useWordpressPageStatus(product, slug) {
  const [content, setContent] = useState(null)

  function sanitizeString(str) {
    return str
      .replace(/[^a-zA-Z0-9 -]/g, '')
      .replace(/\s+/g, '-')
      .toLowerCase()
  }

  useEffect(() => {
    if (!product || !slug) return
    const apiURL = `${product.urls.insights}/wp-json/wp/v2`
    axios
      .get(`${apiURL}/pages?slug=${sanitizeString(slug)}`)
      .then((response) => {
        if (response.data.length > 0) {
          setContent(response.data[0].content.rendered)
        }
      })
      .catch((error) => {
        console.error('Error fetching page', error)
      })
  }, [product, slug])

  return { content }
}
